export const decisioningStudioAgentsAppGroupIdDsaIdDimensions =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions";
